import React from "react";
import {Routes, Route} from "react-router-dom";
import {Container, Separator} from "@chakra-ui/react";
import NavigationBar from "./components/NavigationBar";
import LandingPage from "./pages/LandingPage";
import AIAgentsPage from "./pages/AIAgentsPage";
import PlanTrainDocPage from "./pages/PlanTrainDocPage";
import SensorsPage from "./pages/SensorsPage";
import TrainingAidsPage from "./pages/TrainingAidsPage";
import AboutPage from "./pages/AboutPage";
import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/Footer";
import ContactPage from "./pages/ContactPage";
import TechPage from "./pages/TechPage";
import ConceptPage from "./pages/ConceptPage";
import {Amplify} from 'aws-amplify';
import amplifyconfig from './amplifyconfiguration.json';
import { Toaster } from "./components/ui/toaster";

Amplify.configure(amplifyconfig);

function App() {
    return (
        <>
            <NavigationBar/>
            <Toaster/>
            <Container maxW="container.lg" py={4}>
                <ScrollToTop/>
                <Routes>
                    <Route path="/" element={<LandingPage/>}/>
                    <Route path="/concept" element={<ConceptPage/>}/>
                    <Route path="/plantraindoc" element={<PlanTrainDocPage/>}/>
                    <Route path="/ai-agents" element={<AIAgentsPage/>}/>
                    <Route path="/sensors" element={<SensorsPage/>}/>
                    <Route path="/training_aids" element={<TrainingAidsPage/>}/>
                    <Route path="/about" element={<AboutPage/>}/>
                    <Route path="/contact" element={<ContactPage/>}/>
                    <Route path="/tech" element={<TechPage/>}/>
                </Routes>
            </Container>
            <Separator/>
            <Footer/>
        </>
    );
}

export default App;
